import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* global twttr */
import React from 'react';
import { attachScript } from '../../../../../common/utils/attach-script';
import { AccessibleSocialButton } from './accessible-social-button';
const LIBRARY_URL = 'https://platform.twitter.com/widgets.js';
const buttonOptions = {
  showScreenName: false,
  showCount: false,
  size: 'small'
};
export class TwitterButton extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init", containerNode => twttr.widgets.createFollowButton(this.props.cardData.id, containerNode, buttonOptions));
  }
  attachScript() {
    if (window.twttr) {
      return Promise.resolve();
    }
    return attachScript(LIBRARY_URL);
  }
  render() {
    const {
      isAccessible,
      twitterButtonTitle
    } = this.props;
    return /*#__PURE__*/React.createElement(AccessibleSocialButton, {
      isAccessible: isAccessible,
      title: twitterButtonTitle,
      attachScript: this.attachScript,
      initButton: this.init
    });
  }
}
//# sourceMappingURL=twitter.js.map